export default __webpack_public_path__ + "static/media/iq.59ed2641.svg";